export const getFullName = (firstName, lastName) => {
    const typeofFirstname = typeof firstName;
    const typeofLastname = typeof lastName;

    const conditionOne = typeofFirstname !== 'string';
    const conditionTwo = typeofLastname !== 'string';

    if (conditionOne) {
        throw new Error('Invalid type of argument provided for "firstName"');
    };

    if (conditionTwo) {
        throw new Error('Invalid type of argument provided for "lastName"');
    };


    return `${firstName} ${lastName}`;
};